import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'
import { GET_SHOPIFY_PRODUCTS_QUERY_KEY } from '~/features/shopify/hooks/useGetShopifyProducts'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { toast } from 'sonner'
import { GET_INVENTORY_QUERY_KEY } from '~/features/hooks/useGetInventory'
import { GET_ACTIONS_QUERY_KEY } from './useGetActions'

export const useDeleteActions = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['delete-actions'],
    mutationFn: async (payload: Array<number>) => {
      const promises = await Promise.all(
        payload.map((id) => supabaseApi.from('actions').delete().eq('id', id).select())
      )

      const errors = promises.map((p) => p.error).filter((error) => error !== null)

      if (errors.length > 0) {
        toast.error('Action deletion failed')
        notifyError({
          message: 'Action deletion failed.',
          data: { payload, errorCount: errors.length },
          error: errors[0],
          function: 'useDeleteActions',
        })
        throw new Error('Action deletion failed')
      }

      return promises.map((p) => p.data)
    },
    onSuccess: () => {
      toast.success('Action deleted successfully.')

      // Invalidate both models and shopify products queries
      queryClient.invalidateQueries({ queryKey: [GET_INVENTORY_QUERY_KEY] })
      queryClient.invalidateQueries({ queryKey: [GET_ACTIONS_QUERY_KEY] })
      // Invalidate shopify products query immediately
      queryClient.invalidateQueries({ queryKey: [GET_SHOPIFY_PRODUCTS_QUERY_KEY] })
    },
  })
}
